import { add, format, parseISO } from 'date-fns';
import { WeekMovingFromCurrentWeek, WEEK_DAYS } from 'views/timesheet/consts';

const today = format(new Date(), 'yyyy-MM-dd');
export const generateTheDay = (week) => {
  return format(add(parseISO(today), { days: WeekMovingFromCurrentWeek[week] * WEEK_DAYS }), 'yyyy-MM-dd');
};
